import { useDialog } from '../../hooks/useDialog';
import ActionMenu from './ActionMenu';
import DeleteConfirmDialog from '../dialog/DeleteConfirmDialog';

const ActionMenuDialog = ({ anchorEl, setAnchorEl, onEdit, onDelete }) => {
  const {
    open: isDeleteDialogOpen,
    handleOpen: openDeleteDialog,
    handleClose: closeDeleteDialog,
  } = useDialog();

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEditClick = () => {
    onEdit();
    handleMenuClose();
  };

  const handleDeleteClick = () => {
    openDeleteDialog();
    handleMenuClose();
  };

  const handleDeleteDialogConfirm = async (id) => {
    try {
      await onDelete(id);
      closeDeleteDialog();
    } catch (error) {
      console.error('Failed to delete comment:', error);
    }
  };

  return (
    <>
      <ActionMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        onEdit={handleEditClick}
        onDelete={handleDeleteClick}
      />
      <DeleteConfirmDialog
        open={isDeleteDialogOpen}
        onClose={closeDeleteDialog}
        onConfirm={handleDeleteDialogConfirm}
      />
    </>
  );
};

export default ActionMenuDialog;
